import React from "react";
import Typography from "@mui/material/Typography";
import { notBlank, isBlank, mapIndexed } from "../../util/ext";
import { Box, List, ListItem, ListItemText } from "@mui/material";
import { identity, ifElse, length, pipe, pluck, reject } from "ramda";

const ErrorMessage = ({ error, ...otherProps }) => {
  return (
    <Box {...otherProps}>
      {notBlank(error) && notBlank(error.body) && (
        <Box>
          <List dense>
            {mapIndexed(
              (msg, idx) => (
                <ListItem key={`message:${idx}`}>
                  <ListItemText
                    primary={msg}
                    primaryTypographyProps={{ color: "error" }}
                  />
                </ListItem>
              ),
              pipe(
                pluck("message"),
                reject(isBlank),
                ifElse(length, identity, () => [error.body.message]),
              )(error.body.errors),
            )}
          </List>
        </Box>
      )}

      {notBlank(error) && isBlank(error.body) && notBlank(error.message) && (
        <Typography color="error" variant="body1" component="div">
          {error.message}
        </Typography>
      )}
    </Box>
  );
};
export default ErrorMessage;
